<div class="tooltip-visibility">
    @if (label) {
        <label
            [ngbTooltip]="labelTooltip"
            [ngClass]="{ 'required-field': isRequired && !hideRequired }"
            [for]="controlId"
            class="control-label for"
            >{{ label }}</label
        >
    }
</div>
<div class="icon-tooltip-visibility">
    @if (label) {
        <label
            [ngClass]="{ 'required-field': isRequired && !hideRequired }"
            [for]="controlId"
            class="control-label for"
        >
            {{ label }}
            @if (labelTooltip) {
                <fa-icon
                    class="icon-tooltip"
                    [icon]="faIconName.faInfoCircle"
                    ngbTooltip=""
                    [ngbTooltip]="labelTooltip"
                    triggers="click"
                ></fa-icon>
            }
        </label>
    }
</div>

<ng-content></ng-content>
@if (isError) {
    @for (msg of errorMessages; track msg) {
        <span class="text-danger"> {{ msg }}</span>
    }
}
